import React, { Component } from "react";
import { bool, arrayOf, shape, string, func } from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, withFormik } from "formik";
import { push } from "react-router-redux";
import classNames from "classnames";

import Button from "pages/_components/Button";
import Selector from "pages/_components/fields/formik/Selector";

import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";

import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { evalEqualsValues } from "util/form";
import { getTransferActivityName } from "util/transferInternalTitleLabels";

const FORM_ID = "transactions.list.filters.transaction";

class TransactionFilter extends Component {
    static propTypes = {
        fetching: bool.isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        activities: arrayOf(shape({})).isRequired,
        buttonLabel: string,
        values: shape({}),
        searchBy: string.isRequired,
        selectedFilter: string.isRequired,
        idActivity: string,
    };

    static defaultProps = {
        buttonLabel: null,
        values: {},
        idActivity: undefined,
    };

    filterOnChangeSelect = (activity) => {
        const { dispatch, isDesktop } = this.props;
        if (isDesktop) {
            dispatch(transactionsActions.loadListRequest({ idActivity: activity }, true, false));
        } else {
            dispatch(
                transactionsActions.setFilters({
                    idActivity: activity,
                }),
            );
            dispatch(push(`/transactions/list/filters/results`));
        }
    };

    render() {
        const {
            fetching,
            activities,
            buttonLabel,
            isDesktop,
            values: { activity },
            idActivity,
            searchBy,
            selectedFilter,
        } = this.props;
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const options =
            activities !== null &&
            activities.map(({ activityName, idActivity: activityId }) => ({
                value: activityId,
                label: getTransferActivityName(activityId, activityName),
            }));

        return (
            <Form autoComplete="off" className={classNames("d-flex filters my-0", { "pb-2": !isDesktop })}>
                <Col sm={12} lg={6} md={8}>
                    <Field
                        idForm={FORM_ID}
                        name="activity"
                        component={Selector}
                        searchable={isDesktop}
                        sortByLabel
                        onCustomChange={!isDesktop ? this.filterOnChangeSelect : undefined}
                        options={options}
                        placeholder={i18n.get("transactions.filters.placeholder").toUpperCase()}
                        formGroupClassName={classNames({ "my-0": !isDesktop })}
                    />
                </Col>
                {isDesktop && (
                    <Col sm={12} md={3} className="align-self-flex-end">
                        <Button
                            bsStyle="primary"
                            label={buttonLabel || "product.filters.filter"}
                            loading={fetching}
                            type="submit"
                            image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                            imageStyle="mr-2"
                            className={classNames("filter-button m-0", {
                                "text-transform-none": enableNewSubmitButton,
                            })}
                            disabled={
                                !activity ||
                                (enableNewSubmitButton &&
                                    evalEqualsValues(
                                        {
                                            activity: idActivity,
                                            searchBy,
                                        },
                                        {
                                            activity,
                                            searchBy: selectedFilter,
                                        },
                                    ))
                            }
                        />
                    </Col>
                )}
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    activities: transactionsSelectors.getActivities(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        handleSubmit: ({ activity }, formikBag) => {
            const {
                dispatch,
                isDesktop,
                onlyPendings,
                pendingDispatch,
                selectedFilter,
                dateFrom,
                dateTo,
                orderBy,
            } = formikBag.props;

            if (isDesktop) {
                dispatch(
                    transactionsActions.loadListRequest(
                        { idActivity: activity, filter: selectedFilter, dateFrom, dateTo, orderBy },
                        onlyPendings,
                        pendingDispatch,
                        selectedFilter,
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    transactionsActions.setFilters({
                        idActivity: activity,
                        dateFrom,
                        dateTo,
                        orderBy,
                    }),
                );
                dispatch(push(`/transactions/list/filters/results`));
            }
        },
    }),
)(TransactionFilter);
